import { Component, OnInit } from '@angular/core';
import { Note } from '../../models/note.model';
import { NoteService } from '../../service/note.service';
import { Observable } from 'rxjs';
import { HttpError } from '../../models/http-error.model';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
export class NoteComponent implements OnInit {
  notes$!: Observable<Note[]>;
  skeleton = new Array(1);
  note: Note = {} as Note;
  userId!: number;
  saveLoading = false;
  error: any = {};

  constructor(private noteService: NoteService) {}

  ngOnInit(): void {
    this.notes$ = this.noteService.getNotes(this.userId);
  }

  saveNewNote(): void {
    this.note.userId = this.userId;
    this.saveLoading = true;
    this.noteService.saveNote(this.note).subscribe(
      (response) => {
        this.saveLoading = false;
        this.notes$ = this.noteService.getNotes(this.userId);
      },
      (error: HttpError) => {
        if (error.status === 422) {
          this.error = error.validationError;
        }
        this.saveLoading = false;
      }
    );
  }
}
